import { AppDispatch } from '../../../store/rootStore'
import { getStockAvailabilities } from '../../products/storage'
import { StocksSlice } from '../../products/storage/stocks.slice'
import { CartItem, CartObject } from '../storage/cart.types'

export const checkStockChanges = async (currentCart: CartObject, dispatch: AppDispatch) => {
  const productIds = currentCart.items.map((item) => item.productId)
  const existingItems = [...currentCart.items]

  const items = await getStockAvailabilities({ productIds })
  if (items && items.length > 0) dispatch(StocksSlice.actions.addAvailabilities(items))

  const mergedItems: CartItem[] = currentCart.items.map((product) => {
    const stockAvailabilities = items?.filter((item) => item.productId === product.productId)
    return { ...product, stockAvailabilities }
  })
  const hasStockChanged = mergedItems.some((mergedItem) => {
    const existingItem = existingItems.find((item) => item.productId === mergedItem.productId)
    const mergedItemStock = mergedItem.stockAvailabilities?.find(
      (s) => s.inventLocationId === currentCart.pickupStore?.inventoryLocationId,
    )
    const currentItemStock = existingItem?.stockAvailabilities?.find(
      (s) => s.inventLocationId === currentCart.pickupStore?.inventoryLocationId,
    )

    return (
      !!mergedItemStock &&
      !!currentItemStock &&
      mergedItemStock.inventoryLevelCode !== currentItemStock.inventoryLevelCode
    )
  })

  return { mergedItems, isChanged: hasStockChanged }
}
